<template>
  <section class="applicant__search mb-4">
    <div class="container-fluid">
      <div class="applicant__search__wrapper">
        <div class="row">
          <div class="col-lg-6">
            <div class="input__search__wrapper">
              <div v-if="byCreateDate" class="input__search">
                <div class="input__group mb0">
                  <label for="create-date-from" class="label">{{ $lang.app.CREATION_DATE }} от</label>
                  <input id="create-date-from" type="date" class="input" v-model="form.createDateFrom" @input="submit">
                </div>
                <div class="input__group mb0">
                  <label for="create-date-to" class="label">{{ $lang.app.CREATION_DATE }} до</label>
                  <input id="create-date-to" type="date" class="input" v-model="form.createDateTo" @input="submit">
                </div>
              </div>
              <div v-if="byRegisterDate" class="input__search">
                <div class="input__group mb0">
                  <label for="register-date-from" class="label">{{ $lang.app.REGISTRATION_DATE }} от</label>
                  <input id="register-date-from" type="date" class="input" v-model="form.registerDateFrom" @input="submit">
                </div>
                <div class="input__group mb0">
                  <label for="register-date-to" class="label">{{ $lang.app.REGISTRATION_DATE }} до</label>
                  <input id="register-date-to" type="date" class="input" v-model="form.registerDateTo" @input="submit">
                </div>
              </div>
            </div>
          </div>
          <div v-if="byName" class="col-lg-3">
            <div class="input__group mb0">
              <label for="name" class="label">{{ $lang.app.PROJECT_DENOMINATION }}</label>
              <input id="name" type="text" class="input" placeholder="Введите наименование заявления" v-model="form.name"
                     @input="change">
            </div>
          </div>
          <div v-if="byStatus" class="col-lg-3">
            <div class="input__group mb0 input__add__info">
              <label for="application__type__construction" class="label">{{ $lang.app.STATUS }}</label>
              <div class="select__wrapper">
                <Multiselect
                    @select="submit"
                    id="status"
                    v-model="form.status"
                    :options="statuses"
                    :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                    :searchable="true"
                    :noOptionsText="$lang.app.LIST_EMPTY"
                    :noResultsText="$lang.app.NOT_FOUND">
                </Multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import applicationApi from "../../../api/applicant/application";
import _debounce from 'lodash/debounce';

export default {
  props: {
    query: Object,
    byCreateDate: {
      type: Boolean,
      default: () => true
    },
    byRegisterDate: {
      type: Boolean,
      default: () => true
    },
    byName: {
      type: Boolean,
      default: () => true
    },
    byStatus: {
      type: Boolean,
      default: () => true
    },
  },
  data() {
    return {
      statuses: [],

      form: {
        createDateFrom: this.query.createDateFrom ?? null,
        createDateTo: this.query.createDateTo ?? null,
        registerDateFrom: this.query.registerDateFrom ?? null,
        registerDateTo: this.query.registerDateTo ?? null,
        name: this.query.name ?? '',
        status: this.query.status ?? null,
      }
    }
  },
  created() {
    this.fetchStatuses()
  },
  methods: {
    change: _debounce(function() {
      this.submit()
    }, 1000),
    fetchStatuses() {
      applicationApi.statusList().then((res) => {
        this.statuses = res.map(item => ({
          value: item.id,
          label: this.$lang.$translate({ru: item.nameRu, kg: item.nameKg})
        }))
      })
    },
    submit() {
      this.$emit('submit', this.form)
    },
    reset() {
      this.$emit('reset')
    }
  }
}
</script>